export default __webpack_public_path__ + "static/media/sg-white.5982f370.svg";